import { sortAscending } from '@repo-level/core-front';
import { languages } from 'languages';

import { getLocaleFlagIcon } from 'helpers/cdn';

const availableLanguages = Object.keys(languages).reduce(
  (acc, codeCountry) => {
    const l = languages[codeCountry].map(
      ({ locale, countryIcon, subName }) => ({
        language: locale,
        country: subName ? subName : codeCountry,
        icon: getLocaleFlagIcon(countryIcon),
      })
    );

    return acc.concat(l);
  },
  [] as {
    language: string;
    country: string;
    icon: string;
  }[]
);

const noSortLanguages = availableLanguages.map((lng) => ({
  ...lng,
  name: lng.country.toUpperCase(),
  value: lng.language,
}));

export const optionsLanguages = sortAscending(noSortLanguages, 'name');
